
import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import Button from '../base/Button';

export default function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  const isActive = (path: string) => {
    return location.pathname === path;
  };

  const navItems = [
    { name: 'Home', path: '/' },
    { name: 'Snow Sculpting Workshops', path: '/workshops' },
    { name: 'Café Snow', path: '/cafe' },
    { name: 'About Us', path: '/about' },
    { name: 'Contact', path: '/contact' }
  ];

  return (
    <header className="bg-white/95 backdrop-blur-sm shadow-lg sticky top-0 z-50 border-b border-pink-100">
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between h-20">
          {/* Logos */}
          <div className="flex items-center">
            <Link to="/" className="hover:opacity-80 transition-opacity">
              <img 
                src="https://static.readdy.ai/image/baffbf7ed36148db6e0b9d29f08b4289/ee791e366d2022bcee181d04d5b19845.png" 
                alt="SNOWIN Logo" 
                className="h-16 w-auto"
              />
            </Link>
            <Link to="/cafe" className="hover:opacity-80 transition-opacity ml-2">
              <img 
                src="https://static.readdy.ai/image/baffbf7ed36148db6e0b9d29f08b4289/0871d15dde06427a27a9bfc82ef5d87c.png" 
                alt="Café Snow Logo" 
                className="h-16 w-auto"
              />
            </Link>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex space-x-8">
            <Link to="/" className="text-gray-700 hover:text-blue-600 transition-colors font-medium">
              Home
            </Link>
            <Link to="/workshops" className="text-gray-700 hover:text-blue-600 transition-colors font-medium">
              Snow Sculpting Workshops
            </Link>
            <Link to="/cafe" className="text-gray-700 hover:text-blue-600 transition-colors font-medium">
              Café Snow
            </Link>
            <Link to="/about" className="text-gray-700 hover:text-blue-600 transition-colors font-medium">
              About Us
            </Link>
            <Link to="/contact" className="text-gray-700 hover:text-blue-600 transition-colors font-medium">
              Contact
            </Link>
          </nav>

          <button
            className="md:hidden w-10 h-10 flex items-center justify-center cursor-pointer"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            <i className={`text-2xl ${isMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>

        {isMenuOpen && (
          <div className="md:hidden py-4 border-t border-gray-200">
            <nav className="flex flex-col space-y-4">
              <Link to="/" className="block px-3 py-2 text-gray-700 hover:text-blue-600 transition-colors font-medium">
                Home
              </Link>
              <Link to="/workshops" className="block px-3 py-2 text-gray-700 hover:text-blue-600 transition-colors font-medium">
                Snow Sculpting Workshops
              </Link>
              <Link to="/cafe" className="block px-3 py-2 text-gray-700 hover:text-blue-600 transition-colors font-medium">
                Café Snow
              </Link>
              <Link to="/about" className="block px-3 py-2 text-gray-700 hover:text-blue-600 transition-colors font-medium">
                About Us
              </Link>
              <Link to="/contact" className="block px-3 py-2 text-gray-700 hover:text-blue-600 transition-colors font-medium">
                Contact
              </Link>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
}
